
import { createApp } from 'vue';
import { appName } from "./constants/appUrl";
import router from './router';
import store from './store';
import App from '../js/src/App.vue';

import { plugin, defaultConfig } from '@formkit/vue';
import { QuillEditor } from '@vueup/vue-quill';
import './bootstrap.js';

import PortalVue from 'portal-vue';

import Permission from './src/mixins/permission.vue';
import Components from './src/mixins/components.vue';

import PrimeVue from 'primevue/config';
import 'primevue/resources/themes/lara-light-green/theme.css';
import 'primeicons/primeicons.css';
import Tooltip from 'primevue/tooltip';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';

import RpmInput from '#components/RpmInput';
import RpmButton from '#components/RpmButton';
import Card from '#components/Card';
import CopySpan from '#components/CopySpan';

import 'vue-good-table-next/dist/vue-good-table-next.css'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

import VMask from "@ssibrahimbas/v-mask";

import {VueReCaptcha} from "vue-recaptcha-v3";


const app = createApp(App);

function isLoggedIn() {
  return sessionStorage.getItem('token');
}

function passwordChanged() {
  let userForcedToChangePassword = JSON.parse(sessionStorage.getItem('user'))
  return !userForcedToChangePassword.force_change_password
}

router.beforeEach((to, from, next) => {

  document.title = to.meta.name + ' | ' + appName;

  if (to.meta.requiresAuth && !isLoggedIn()) {

    next({
      path: '/login',
    });

  } else if (to.meta.guest) {

    if (isLoggedIn()) next({
      path: '/services-inbox',
    });
    else next();

  } else if (to.meta.requiresChangedPassword) {

    if (passwordChanged()) next();
    else next({
      path: '/change-password'
    });

  } else next();

});


app.use(PrimeVue);
app.use(PortalVue);
app.use(ToastService);

app.use(router);
app.use(store);
defaultConfig({
    theme: 'genesis'
});
app.use(plugin, defaultConfig);
app.use(VMask);

if (process.env.MIX_RECAPTCHA_V3_SITE_KEY) {
    app.use(VueReCaptcha, {
        siteKey: process.env.MIX_RECAPTCHA_V3_SITE_KEY
    });
}

app.component('Toast', Toast);
app.component('QuillEditor', QuillEditor);
app.component('rpm-input', RpmInput);
app.component('rpm-button', RpmButton);
app.component('card', Card);
app.component('copy-span', CopySpan);

app.directive('tooltip', Tooltip);

app.mixin(Permission);
app.mixin(Components);

router.isReady().then(() => {
  app.mount('#app');
})
